var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveChanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 17,
    viewBox: "0 0 113 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.875 11.4608L23.575 10.6608C24.235 11.3508 25.155 11.8008 26.115 11.8008C27.325 11.8008 28.035 11.2008 28.035 10.3108C28.035 9.37079 27.365 9.0708 26.505 8.6908L25.185 8.11078C24.325 7.74078 23.325 7.10078 23.325 5.74078C23.325 4.38078 24.545 3.30078 26.215 3.30078C27.305 3.30078 28.275 3.7708 28.925 4.4408L28.305 5.1908C27.745 4.6608 27.065 4.33075 26.215 4.33075C25.185 4.33075 24.505 4.85078 24.505 5.67078C24.505 6.56078 25.305 6.8908 26.025 7.1908L27.335 7.76074C28.395 8.22074 29.225 8.85076 29.225 10.2208C29.225 11.6708 28.025 12.8307 26.095 12.8307C24.805 12.8307 23.685 12.3008 22.875 11.4708V11.4608Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.606 10.8916C31.606 9.4116 32.8859 8.66162 35.7859 8.35162C35.7859 7.47162 35.4959 6.63159 34.3759 6.63159C33.5859 6.63159 32.8759 7.00163 32.3459 7.36163L31.8959 6.57159C32.5259 6.16159 33.4759 5.68164 34.5659 5.68164C36.2259 5.68164 36.926 6.78163 36.926 8.48163V12.6616H35.976L35.8759 11.8516H35.8359C35.1859 12.3916 34.4259 12.8316 33.5859 12.8316C32.4459 12.8316 31.5859 12.1216 31.5859 10.8916H31.606ZM35.7859 11.0016V9.11163C33.5059 9.38163 32.736 9.94165 32.736 10.8116C32.736 11.5816 33.256 11.9016 33.926 11.9016C34.596 11.9016 35.1259 11.5816 35.7859 11.0016Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2246 5.85156H40.4146L41.7046 9.72156C41.9046 10.3816 42.1246 11.0816 42.3346 11.7316H42.3946C42.5946 11.0816 42.8246 10.3916 43.0246 9.72156L44.3146 5.85156H45.4446L43.0346 12.6616H41.6946L39.2346 5.85156H39.2246Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3047 9.2616C47.3047 7.0416 48.7947 5.68164 50.3647 5.68164C52.1047 5.68164 53.0847 6.93159 53.0847 8.88159C53.0847 9.12159 53.0647 9.37162 53.0347 9.53162H48.4547C48.5347 10.9716 49.4147 11.9116 50.7147 11.9116C51.3647 11.9116 51.9047 11.7016 52.4147 11.3716L52.8247 12.1316C52.2247 12.5216 51.5047 12.8416 50.5747 12.8416C48.7547 12.8416 47.3147 11.5116 47.3147 9.28162L47.3047 9.2616ZM52.0647 8.71161C52.0647 7.35161 51.4547 6.60162 50.3847 6.60162C49.4247 6.60162 48.5747 7.37161 48.4347 8.71161H52.0647Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3652 8.07074C59.3652 5.11074 61.1153 3.30078 63.4453 3.30078C64.5653 3.30078 65.4353 3.84079 65.9753 4.43079L65.3352 5.1908C64.8552 4.6708 64.2452 4.32074 63.4652 4.32074C61.7252 4.32074 60.5753 5.74076 60.5753 8.03076C60.5753 10.3208 61.6753 11.7908 63.4253 11.7908C64.3053 11.7908 64.9652 11.4107 65.5552 10.7607L66.1953 11.4908C65.4653 12.3308 64.5652 12.8207 63.3752 12.8207C61.0852 12.8207 59.3652 11.0508 59.3652 8.06079V8.07074Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9043 2.67993H70.0543V5.40991L70.0143 6.80994C70.6443 6.18994 71.3443 5.67993 72.2743 5.67993C73.7143 5.67993 74.3543 6.6099 74.3543 8.3399V12.6499H73.2043V8.47992C73.2043 7.20992 72.8243 6.66992 71.9143 6.66992C71.2143 6.66992 70.7343 7.02991 70.0543 7.71991V12.6499H68.9043V2.66992V2.67993Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2153 10.8916C77.2153 9.4116 78.4953 8.66162 81.3953 8.35162C81.3953 7.47162 81.1053 6.63159 79.9853 6.63159C79.1953 6.63159 78.4853 7.00163 77.9553 7.36163L77.5053 6.57159C78.1353 6.16159 79.0853 5.68164 80.1753 5.68164C81.8353 5.68164 82.5353 6.78163 82.5353 8.48163V12.6616H81.5853L81.4853 11.8516H81.4453C80.7953 12.3916 80.0353 12.8316 79.1953 12.8316C78.0553 12.8316 77.1953 12.1216 77.1953 10.8916H77.2153ZM81.3953 11.0016V9.11163C79.1153 9.38163 78.3453 9.94165 78.3453 10.8116C78.3453 11.5816 78.8653 11.9016 79.5353 11.9016C80.2053 11.9016 80.7353 11.5816 81.3953 11.0016Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8145 5.85162H86.7645L86.8644 6.8316H86.9044C87.5544 6.1916 88.2544 5.68164 89.1844 5.68164C90.6144 5.68164 91.2645 6.61161 91.2645 8.34161V12.6516H90.1144V8.48163C90.1144 7.21163 89.7344 6.67163 88.8344 6.67163C88.1344 6.67163 87.6545 7.03162 86.9745 7.72162V12.6516H85.8245V5.84161L85.8145 5.85162Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0742 13.9699C94.0742 13.3899 94.4442 12.8399 95.0742 12.4299V12.3699C94.7242 12.1499 94.4642 11.7899 94.4642 11.2499C94.4642 10.6799 94.8642 10.2299 95.2142 9.98993V9.92993C94.7642 9.57993 94.3342 8.90991 94.3342 8.09991C94.3342 6.60991 95.5042 5.66992 96.8842 5.66992C97.2642 5.66992 97.5942 5.7399 97.8442 5.8399H100.224V6.72992H98.8242C99.1442 7.03992 99.3742 7.54988 99.3742 8.12988C99.3742 9.58988 98.2742 10.4899 96.8842 10.4899C96.5542 10.4899 96.1742 10.4099 95.8742 10.2599C95.6242 10.4699 95.4442 10.6899 95.4442 11.0599C95.4442 11.4899 95.7242 11.7999 96.6342 11.7999H97.9642C99.5442 11.7999 100.344 12.2999 100.344 13.4299C100.344 14.6899 99.0042 15.7799 96.9042 15.7799C95.2342 15.7799 94.0842 15.1299 94.0842 13.9499L94.0742 13.9699ZM99.2042 13.6099C99.2042 12.9799 98.7242 12.7699 97.8342 12.7699H96.6642C96.4042 12.7699 96.0842 12.7399 95.7842 12.6699C95.2942 13.0199 95.0842 13.4199 95.0842 13.8099C95.0842 14.5399 95.8242 14.9999 97.0542 14.9999C98.3542 14.9999 99.2042 14.3199 99.2042 13.6099ZM98.3342 8.10992C98.3342 7.11992 97.6942 6.5199 96.8842 6.5199C96.0742 6.5199 95.4342 7.10992 95.4342 8.10992C95.4342 9.10992 96.0942 9.72992 96.8842 9.72992C97.6742 9.72992 98.3342 9.09992 98.3342 8.10992Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.065 9.2616C102.065 7.0416 103.555 5.68164 105.125 5.68164C106.865 5.68164 107.845 6.93159 107.845 8.88159C107.845 9.12159 107.825 9.37162 107.795 9.53162H103.205C103.285 10.9716 104.165 11.9116 105.465 11.9116C106.115 11.9116 106.655 11.7016 107.155 11.3716L107.565 12.1316C106.965 12.5216 106.245 12.8416 105.315 12.8416C103.505 12.8416 102.055 11.5116 102.055 9.28162L102.065 9.2616ZM106.825 8.71161C106.825 7.35161 106.215 6.60162 105.145 6.60162C104.185 6.60162 103.335 7.37161 103.195 8.71161H106.825Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.885 11.8816L110.455 11.1216C111.045 11.6016 111.645 11.9316 112.465 11.9316C113.355 11.9316 113.805 11.4516 113.805 10.8716C113.805 10.1716 113.005 9.8616 112.245 9.5816C111.285 9.2316 110.215 8.76163 110.215 7.61163C110.215 6.46163 111.085 5.68164 112.565 5.68164C113.415 5.68164 114.155 6.0316 114.685 6.4516L114.135 7.19165C113.665 6.84165 113.185 6.5816 112.585 6.5816C111.725 6.5816 111.335 7.04165 111.335 7.56165C111.335 8.21165 112.075 8.45164 112.845 8.74164C113.825 9.11164 114.925 9.51165 114.925 10.8116C114.925 11.9116 114.045 12.8316 112.445 12.8316C111.475 12.8316 110.545 12.4216 109.905 11.8816H109.885Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.565 2.05859H0.375",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4354 13.5684L0.275391 13.5984",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 13.6785L0.705017 1.89844",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0759 13.6886C12.0659 11.3986 12.0659 8.90859 12.0759 6.55859V13.6886Z",
    fill: "#4CC8EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0759 13.6886C12.0659 11.3986 12.0659 8.90859 12.0759 6.55859",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 7.50018L11.6848 0.660156",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 9.16034L13.345 2.32031",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50391 10.4092C4.00391 9.41924 4.5039 8.42922 4.9939 7.44922L3.50391 10.4092Z",
    fill: "#4CC8EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50391 10.4092C4.00391 9.41924 4.5039 8.42922 4.9939 7.44922",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70447 9.10938L3.31445 10.5994",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5537 2.41943L11.5938 0.439453",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveChanges);
export default __webpack_public_path__ + "static/media/save-changes.060e13e683f38d37e3d9ef86846d6f87.svg";
export { ForwardRef as ReactComponent };